import {
    fetchMaterialSummaryReport,
    readMaterialSummaryTaskPaneFilterFromDom,
} from '../../../material-summary';
import { formatMaterialSummaryRecordsToTabularSheet } from '../../formatters/material-summary-tabular.formatter';
import type { ReportFetchContext, ReportFetchResult } from '../report-fetch.types';
import { completeFetchedReportWithTabularWrite } from '../utils/complete-fetched-report-with-tabular-write.util';

/**
 * Material Summary target: Get-Material-Summary, then tabular formatter / worksheet writer.
 */
export async function executeMaterialSummaryReportingTargetFetch(
    ctx: ReportFetchContext
): Promise<ReportFetchResult> {
    const read = readMaterialSummaryTaskPaneFilterFromDom();
    const fetchResult = await fetchMaterialSummaryReport(ctx.accessToken, read, {
        fetchMaterialSummaryActivity: (token, payload) =>
            ctx.deps.materialSummaryApi.fetchMaterialSummaryActivity(token, payload),
    });
    return completeFetchedReportWithTabularWrite(
        fetchResult,
        formatMaterialSummaryRecordsToTabularSheet,
        (payload, mode) => ctx.deps.tabularSheetWriter.writeTabularSheetToWorksheet(payload, mode),
        ctx.tabularWriteMode
    );
}
